import React from "react";
import { Helmet } from "react-helmet";
import Header from "components/shared/header/";

function NotFound() {
  return (
    <div className="page">
      <Helmet>
        <title>404 - Page Not Found</title>
      </Helmet>
      <Header height={"50vh"}>
        <h1>404</h1>
        <h3>
          <a href="/">back to home</a>
        </h3>
      </Header>
      <main className="page-fill-panel" />
    </div>
  );
}

export default NotFound;
